<mat-card class="cardWithShadow">
    <mat-card-header style="display: flex; flex-direction: column;">
        <mat-card-title>{{ 'ORDER.MANUFACTURING.TITLE' | translate }}</mat-card-title>
        <span class="subtitle">{{ 'ORDERS_REGISTERED_ON_ACCOUNT' | translate }}</span>
    </mat-card-header>
    <mat-card-content class="card-body">
        <div class="table-responsive">
            <mat-progress-bar *ngIf="loading" mode="indeterminate" style="margin-top: 20px;"></mat-progress-bar>
            <table mat-table [dataSource]="orders" class="w-100" style="margin-top: 20px;">

                <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'ORDER_CREATION_DATE' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let order">
                        <span>{{order.createdAt | date: 'dd/MM/yyyy - hh:mm' }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="files">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ORDER_FILES' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let order" class="f-s-14">
                        <span>{{order.orderRows.length}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ORDER_PRICE' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let order" class="f-s-14">
                        <span>{{order.price}} USD</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ORDER_STATUS' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let order" class="f-s-14">
                        <ng-container *ngIf="isOrderApproved(order)">
                            <span *ngIf="order.status === 'pending'" class="pill grey-pill">{{ 'ORDER_PENDING' |
                                translate }}</span>
                            <span *ngIf="order.status === 'inProgress'" class="pill orange-pill">{{ 'ORDER_IN_PROGRESS'
                                | translate }}</span>
                            <span *ngIf="order.status === 'shipped'" class="pill blue-pill">{{ 'ORDER_SHIPPED' |
                                translate }}</span>
                            <span *ngIf="order.status === 'delivered'" class="pill green-pill">{{ 'ORDER_DELIVERED' |
                                translate }}</span>
                        </ng-container>
                        <span *ngIf="!isOrderApproved(order)" class="pill grey-pill">{{ 'ORDER_PENDING' | translate
                            }}</span>
                        <ng-container *ngIf="isUserPrintingHub">
                            <p-dropdown appendTo="body" panelStyleClass="order-status-dropdown"
                                [options]="orderStatusOptions" [(ngModel)]="order.status" optionLabel="label"
                                optionValue="value" (onChange)="onChangeStatus(order)">
                                <ng-template pTemplate="selectedItem">
                                    <div class="pill" [ngClass]="[order.status]">{{ order.statusString }}</div>
                                </ng-template>
                                <ng-template let-orderStatusOption pTemplate="item">
                                    <div class='order-status-option-item' [ngClass]="[orderStatusOption.value]">
                                        {{orderStatusOption.label}}</div>
                                </ng-template>
                            </p-dropdown>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="approved">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ORDER_APPROVED' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let order" class="f-s-14">
                        <ng-container *ngIf="!isApprovingOrder || selectedOrder !== order.ID">
                            <span *ngIf="order.approved" class="pill green-pill">{{ 'ORDER_APPROVED' | translate
                                }}</span>
                            <span *ngIf="!order.approved" class="pill red-pill">{{ 'ORDER_NOT_APPROVED' | translate
                                }}</span>
                        </ng-container>
                        <p-skeleton *ngIf="isApprovingOrder && selectedOrder === order.ID" width="90%" height="1.5em"
                            borderRadius="16px"></p-skeleton>
                    </td>
                </ng-container>

                <ng-container matColumnDef="paymentStatus">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ORDER_PAYMENT_STATUS' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let order" class="f-s-14">
                        <ng-container *ngIf="!isPayingOrder || selectedOrder !== order.ID">
                            <span *ngIf="order.paid" class="pill green-pill">{{ 'ORDER_PAID' | translate }}</span>
                            <span *ngIf="!order.paid" class="pill red-pill">{{ 'ORDER_NOT_PAID' | translate
                                }}</span>
                        </ng-container>
                        <p-skeleton *ngIf="isPayingOrder && selectedOrder === order.ID" width="60%" height="1.5em"
                            borderRadius="16px"></p-skeleton>
                    </td>
                </ng-container>

                <ng-container matColumnDef="paymentMethod">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ORDER_PAYMENT_METHOD' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let order" class="f-s-14">
                        <span>{{order.paymentMethod}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ORDER_ACTIONS' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let order" class="f-s-14">
                        <a *ngIf="isUserPrintingHub && !order.approved" class="m-r-10 cursor-pointer icon"
                            matTooltip="Approve" (click)="onApproveOrder(order)">
                            <i-tabler name="check" class="icon-18"></i-tabler>
                        </a>
                        <a *ngIf="isUserPrintingHub && order.approved" class="m-r-10 cursor-pointer icon"
                            matTooltip="Disapprove" (click)="onApproveOrder(order)">
                            <i-tabler name="x" class="icon-18"></i-tabler>
                        </a>
                        <a *ngIf="(isUserDistributorProfessional || isUserIndividualClient) && !order.paid"
                            class="m-r-10 cursor-pointer icon" matTooltip="Pay" (click)="onPayOrder(order)">
                            <i-tabler name="currency-dollar" class="icon-18"></i-tabler>
                        </a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="orderId">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ORDER_ORDER_ID' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let order" class="f-s-14">
                        <span>{{order.ID}}</span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns" class="hoverable-row"></tr>
            </table>

            <ng-container *ngIf="orders.length === 0 && !loading">
                <p class="no-orders-text">{{ 'ORDER_NO_ORDERS_TO_SHOW' | translate }}</p>
            </ng-container>

        </div>
        <div class="table-footer" *ngIf="orders.length > 0 && moreOrdersParameters">
            <button mat-raised-button color="primary" (click)="onLoadMoreOrders()">{{ 'LOAD_MORE' | translate
                }}</button>
        </div>
    </mat-card-content>
</mat-card>

<app-pay-order-modal *ngIf="showPayOrderModal" [(visible)]="showPayOrderModal" [order]="selectedOrderToPay"
    (orderPaid)="orderPaid($event)">
</app-pay-order-modal>